import React from "react";

import { GridCell } from "../../atoms/Layout/GridCell/GridCell";
import styles from "./CrossPromotion.css";
import { truncatedText } from "../../../utils";

export type CrossPromotionProps = {
  link?: string;
  imageSrc?: string;
  mobileImageSrc?: string; // New prop for mobile image source
  htmlText: string;
  onClick: () => void;
  showImages?: boolean; // New prop to control image visibility
  maxTextLength?: number; // New prop for maximum text length
};

export class CrossPromotion extends React.Component<CrossPromotionProps> {
  render() {
    const {
      htmlText,
      link,
      onClick,
      imageSrc,
      mobileImageSrc,
      showImages,
      maxTextLength,
    } = this.props;
    const truncateText = truncatedText(htmlText, maxTextLength);
    const hasDesktopImage = showImages && imageSrc;
    const hasMobileImage = showImages && mobileImageSrc;

    return (
      <a
        href={link}
        target="_blank"
        className={styles.linkUnset}
        onClick={onClick}
      >
        <Container>
        {showImages && (
            <>
              {hasDesktopImage && (
                <GridCell
                  size={4}
                  className={`${styles.col} ${styles.desktopOnly}`}
                >
                  <PromoImage desktopImageSrc={imageSrc} />
                </GridCell>
              )}
              {hasMobileImage && (
                <GridCell
                  size={4}
                  className={`${styles.col} ${styles.mobileOnly}`}
                >
                  <PromoImage mobileImageSrc={mobileImageSrc} />
                </GridCell>
              )}
            </>
          )}
          <GridCell
            size={this.calculateGridSize(hasDesktopImage, hasMobileImage)}
            className={styles.col}
          >
            <PromoContent dangerouslySetInnerHTML={{ __html: truncateText }} />
          </GridCell>
        </Container>
      </a>
    );
  }

  calculateGridSize(hasDesktopImage: string, hasMobileImage: string) {
    if (!hasDesktopImage && !hasMobileImage) {
      return 12;
    }
  
    const isMobileView = typeof window !== "undefined" && window.innerWidth < 768;
    const hasImage = (isMobileView && hasMobileImage) || (!isMobileView && hasDesktopImage);
    
    return hasImage ? 8 : 12;
  }
}

const Container = (props: any) => (
  <div className={styles.crossPromoContainer} {...props} />
);
const PromoContent = (props: any) => (
  <div className={styles.crossPromoContent} {...props} />
);
type PromoImageProps = {
  desktopImageSrc?: string;
  mobileImageSrc?: string;
};

const PromoImage = ({ desktopImageSrc, mobileImageSrc }: PromoImageProps) => (
  <>
    {desktopImageSrc && (
      <div
        className={styles.desktopImage}
        style={{ backgroundImage: `url("${desktopImageSrc}")` }}
      />
    )}
    {mobileImageSrc && (
      <div
        className={styles.mobileImage}
        style={{ backgroundImage: `url("${mobileImageSrc}")` }}
      />
    )}
  </>
);
